<template>
    <fieldset class="form-group">
        <label for="phone_number">Contact phone number</label>
        <input
        id="phone_number"
        v-model="inputValue"
        v-mask="'###-###-####'"
        type="tel"
        class="form-control"
        title="Please type valid phone number."
        required
        :name="name"
        >
    </fieldset>
</template>
<script>
export default {
    name: 'TheSellCarFormPhone',

    props: {
        value: {
            type: String,
            default: '',
            required: true
        },
        name: {
            type: String,
            default: ''
        }
    },

    data: () => ({
        inputValue: ''
    }),

    created() {
        this.inputValue = (this.value || '').replace(/-/g, '')
    }
}
</script>